
import { ICurrentEmployerViewState } from './state';
import { createReducer, on, State, Action } from '@ngrx/store';
import {
  onNgrxForms, onNgrxFormsAction, SetValueAction
} from 'ngrx-forms';
import { CurrentEmploymentModel } from 'src/app/model/current-employment.model';
import { ResponseAction } from './actions';

export const state: ICurrentEmployerViewState = {
  employer: new CurrentEmploymentModel()
};

const reducer = createReducer(state,
  onNgrxForms(),
  onNgrxFormsAction(SetValueAction, (state, action) => {
    return state;
  }),
  on(ResponseAction, (state, { payload }) => {
    return {
      ...state,
      employer: payload
    };
  })
);

export function currentEmployerViewReducer(state: any | undefined, action: Action) {
  return reducer(state, action);
}
